






















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { bpList, bpOperate, queryBpUser, queryBpSector } from '@/api/kp';
import { orderByList, statusList, sectorList, priorityList, bpSeedColumnsUnresolved, bpSeedColumnResolved } from '@/utils/kp';
import moment from 'moment';
import axios from 'axios';
import JSZip from 'jszip';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: { ...mapGetters(['userInfo']) }
})
class BpList extends Vue {
  userInfo: any;
  data: any[] = [];
  resolveStatus: any = 1;
  status: any = 2;
  orderBy: any = 1;
  priority: any = -1;
  sector: any = null;
  manager: any = null;

  orderByList: any = orderByList;
  statusList: any = statusList;
  sectorList: any = [];
  priorityList: any = priorityList;
  managerList: any = [];

  tableLoading: boolean = true;
  confirmLoading: boolean = false;

  bpSeedColumns: any[] = bpSeedColumnsUnresolved;
  showSubmit: boolean = false;
  submitId: any = null;
  fetching: boolean = false;
  userKeyWord: string = '';

  rules: any = {
    status: [{ required: true, message: '请选择沟通结论', trigger: 'blur' }],
    priority: [{ required: true, message: '请选择优先级', trigger: 'change' }],
    illustrate: [{ required: true, message: '请填写说明', trigger: 'change' }]
  };

  submitForm: any = {
    status: 2,
    priority: null,
    illustrate: '',
    notifyDate: null
  };

  pageInfo: any = {
    page: 1,
    pageSize: 10,
    total: 0
  };

  @Prop()
  collapsed;

  @Watch('collapsed')
  getCollapsed(val) {
    setTimeout(() => {
      this.$forceUpdate();
    }, 80);
  }

  tillToday(time) {
    return time <= moment(new Date());
  }

  async created() {
    let resolveStatus = this.$route.query.resolveStatus;
    if (resolveStatus) {
      this.resolveStatus = +resolveStatus;
    }
    await this.getUserList();
    await this.getSectionList();
    this.initSelection();
    this.regetList();
  }

  resolveStatusChange() {
    let { resolveStatus } = this;
    //@ts-ignore
    this.$ga.gaUploadCustomEvent('客户-BP投递-筛选待处理/已处理',resolveStatus === 1 ? '待处理' : '已处理');
    if (resolveStatus === 1) {
      this.bpSeedColumns = bpSeedColumnsUnresolved;
    } else {
      this.bpSeedColumns = bpSeedColumnResolved;
    }
    this.initSelection();
    this.regetList();
  }

  async getUserList() {
    try {
      let res = await queryBpUser();
      if (res.code === 200) {
        this.managerList = res.data;
      }
    } catch (e) {}
    this.managerList.unshift({ id: -1, name: '全部' });
  }

  async getSectionList() {
    try {
      let res = await queryBpSector();
      if (res.code === 200) {
        this.sectorList = res.data;
      }
    } catch (e) {}
    this.sectorList.unshift({ id: -1, name: '全部' });
  }

  initSelection() {
    const { id } = this.userInfo || {};
    let managerUser = this.managerList.find(_ => _.id === id);
    if (managerUser) {
      this.manager = managerUser.id;
    } else {
      this.manager = -1;
    }
    this.sector = -1;
  }

  async regetList() {
    this.pageInfo.page = 1;
    this.getList();
  }

  async getList() {
    try {
      let { resolveStatus, sector, status, priority, orderBy, manager } = this;
      let body;
      if (resolveStatus === 1) {
        body = {
          status: 0,
          sector,
          manager
        };
      } else {
        body = {
          status,
          sector,
          priority,
          orderBy,
          manager
        };
      }
      body = {
        ...body,
        page: this.pageInfo['page'],
        pageSize: this.pageInfo['pageSize']
      };
      this.tableLoading = true;
      let res = await bpList(body);
      if (res.code === 200) {
        let data = res.data.list || [];
        data.forEach(_ => {
          _.createAt = moment(_.createAt).format('YYYY-MM-DD');
          _.updateAt = moment(_.updateAt).format('YYYY-MM-DD');
          let status = statusList.find(_1 => _1.value === _.status);
          let priority = priorityList.find(_1 => _1.value === _.priority);
          _.status = status ? status.name : '';
          _.priority = priority ? priority.name : '';
          _.manager = _.manager || '暂无';
          _.sector = _.sector || '暂无';
          try {
            _.video = _.video ? JSON.parse(_.video) : null;
            _.bp = _.bp ? JSON.parse(_.bp) : null;
            _.files = _.files ? JSON.parse(_.files) : [];
          } catch {
            _.video = null;
            _.bp = null;
            _.files = [];
          }
        });

        this.data = data;
        this.tableLoading = false;
        this.pageInfo['total'] = res.data.total;
      }
    } catch (err) {
      console.log(err);
    }
  }

  toDeatil({ name, url }) {
    if (/\.docx?$/i.test(name) || /\.pptx?$/i.test(name)) {
      window.open(`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`);
    } else if (/\.mp4$/i.test(name) || /\.mov$/i.test(name)) {
      window.open(`${window.origin}/pdfview?url=${encodeURIComponent(url)}&type=bpVideo`);
    } else {
      window.open(url);
    }
  }

  async download(file, name) {
    this.$message.info('文件下载中，请稍后');
    let url = file.url;
    let result: any = /\.[a-zA-z0-9]{3,5}\?/.exec(url);
    let type = '';
    if (result[0]) {
      type = result[0].slice(1, -1);
    }
    try {
      let data = await this.getFile(url);
      let fileFullName = `${name}.${type}`;
      this.saveFile(data, fileFullName);
    } catch (e) {
      this.$message.error('文件下载失败');
    }
  }

  downloadFiles(info) {
    this.$message.info('文件下载中，请稍后');
    let { name, files, createAt } = info;
    createAt = createAt.split('-').join('');
    let zip = new JSZip();
    const cache = {};
    const promises = files.map(_ => {
      return this.getFile(_.url).then(data => {
        zip.file(_.name, data, { binary: true });
      });
    });
    Promise.all(promises)
      .then(() => {
        zip.generateAsync({ type: 'blob' }).then(content => {
          this.saveFile(content, `${name}-${createAt}.zip`);
        });
      })
      .catch(e => {
        this.$message.error('文件下载失败');
      });
  }

  async getFile(url) {
    return axios({
      url,
      method: 'get',
      responseType: 'blob'
    })
      .then(res => {
        if (!res.data) {
          throw new Error();
        }
        return res.data;
      })
      .catch(res => {});
  }

  async saveFile(data, name) {
    let contentUrl = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = contentUrl;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      this.$message.success('文件下载完成');
    }, 300);
    window.URL.revokeObjectURL(contentUrl);
    document.body.removeChild(link);
  }

  // 切换分页
  pageChange(page, pageSize) {
    this.pageInfo['page'] = page;
    this.pageInfo['pageSize'] = pageSize;
    this.getList();
  }


  handleFilterChange(id, value = {}) {
    //@ts-ignore
    this.$ga.gaUploadCustomEvent(
      '客户-BP投递-'
      +(this.resolveStatus === 2 ? '已处理' : '待处理')
      +'-'+id, value
    );
    this.regetList();
  }

  finish(info) {
    this.showSubmit = true;
    this.submitForm = {
      status: 2,
      priority: null,
      illustrate: ''
    };
    this.submitId = info.id;
  }

  submit() {
    (this.$refs.form as any).validate(valid => {
      if (valid) {
        this.operate();
      }
    });
  }

  async operate() {
    try {
      let { submitForm, submitId } = this;
      let body: any = {
        id: submitId,
        status: submitForm.status,
        illustrate: submitForm.illustrate
      };
      if (submitForm.status === 2) {
        (body.priority = submitForm.priority), (body.notifyDate = submitForm.notifyDate ? moment(submitForm.notifyDate).unix() : '');
      }
      let res = await bpOperate(body);
      if (res.code === 200) {
        this.$message.success('提交成功');
        this.showSubmit = false;
        this.getList();
      }
    } catch (error) {}
  }
}

export default BpList;
